import urls from 'urls';
import {webviewOpenEventOverview} from '~/ViewInvitation/webview/webview';
import {Button} from '~library/atoms/Button';
import {Link} from '~library/atoms/Link';

export const ManageEventCTA = ({
  renderForWebview = false,
  eventId,
  isLargeAndUp,
  standaloneBtn = false,
}) => {
  if (renderForWebview) {
    // Webview; render as button with JS bridge function as onClick
    return (
      <Button
        variant="primary"
        size="large"
        fullWidth={!isLargeAndUp || standaloneBtn}
        data-qa-id="invitation-manage"
        className="view-invitation__manage-invitation-link"
        onClick={() => webviewOpenEventOverview({eventId})}
      >
        Manage event
      </Button>
    );
  }

  // Not webview; render as link with event overview URL as href
  return (
    <Link
      variant="large"
      as="primary"
      fullWidth={!isLargeAndUp || standaloneBtn}
      data-qa-id="invitation-manage"
      // biome-ignore lint/style/useNamingConvention: existing error
      href={urls.get('event_dashboard', {event_id: eventId})}
      className="view-invitation__manage-invitation-link"
    >
      Manage event
    </Link>
  );
};
